import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createEncoder } from '../api/encoderApi';

export const useEncoderForm = ({ idPaciente, tiempo5STS = '' }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    codigoPrueba: '',
    velocidad: '',
    potencia: '',
    distancia: '',
    tiempo5STS,
  });
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  useEffect(() => {
    if (tiempo5STS) {
      setFormData((prev) => ({ ...prev, tiempo5STS }));
    }
  }, [tiempo5STS]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const guardarDatos = async () => {
    const userId = localStorage.getItem('id');
    try {
      await createEncoder({
        pacienteId: idPaciente,
        userId,
        payload: {
          codigoPrueba: formData.codigoPrueba,
          velocidad: formData.velocidad,
          potencia: formData.potencia,
          distancia: formData.distancia,
          tiempo5STS: formData.tiempo5STS,
        },
      });
      setOpenGood(true);
      setTimeout(() => { navigate('/home'); }, 2000);
    } catch (error) {
      console.error('Error al guardar el encoder:', error);
      setOpenError(true);
    }
  };

  return {
    formData,
    openGood,
    openError,
    setOpenGood,
    setOpenError,
    handleChange,
    guardarDatos,
  };
};
